<template>
	<div class="resetpassword">
		<backgroundone v-slot:backgroundslot>
			<resetpassword>
				
			</resetpassword>
		</backgroundone>
	</div>
</template>

<script>
	import backgroundone from '../components/background/backgroundone.vue'
	import resetpassword from '../components/resetpasswordbox/resetpassword.vue'
	export default {
	  name: 'ResetPassword',
		components:{
			backgroundone,
			resetpassword
		}
	}
</script>

<style>
</style>
